export default __webpack_public_path__ + "static/media/1COVER-Cloudxier-PTBIS.afcde09a.jpg";